import "./styles.scss";

import { useTranslation } from "react-i18next";

import Select from "../../index";

import task_status_data from "libs/task_status_data.json";

const Status = ({
  labelCta,
  selected,
  optionFilters,
  optionsDisabled,
  forceBottom,
  isCompletelyDisabled,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <Select
      variant="status"
      label={t("Status")}
      labelCta={labelCta}
      placeholder={{
        icon: "_",
        label: t("Select status"),
      }}
      options={task_status_data
        .filter((item) =>
          !isCompletelyDisabled ? !optionFilters?.includes(item.key) : true,
        )
        .map((item) => ({
          ...item,
          variant: item?.color,
          icon: "_",
          label: t(item.label),
        }))}
      selected={selected}
      value={selected?.value}
      optionsDisabled={optionsDisabled}
      forceBottom={forceBottom}
      isCompletelyDisabled={isCompletelyDisabled}
      onChange={
        typeof onChange === "function"
          ? (option) => onChange(option)
          : undefined
      }
    />
  );
};

export default Status;
